import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';

import { db } from './firebase';

const getUserDocRef = (user) => {
  const userEmail = user?.email;
  return doc(db, `users/${userEmail}`);
};

const getDeviceSettingsDocRef = (deviceId) => {
  return doc(db, `device-setting/${deviceId}`);
};

const getDeviceSettingsGeoFencesDocRef = (deviceId) => {
  return doc(db, `device-setting/${deviceId}/geo_fences`);
};

export const getUserDocument = (user) => {
  const userDocRef = getUserDocRef(user);
  return getDoc(userDocRef);
};

export const updateUserDocument = (user, userConfig) => {
  return updateDoc(getUserDocRef(user), { ...userConfig });
};

export const updateDeviceSettingsDocument = (deviceId, deviceConfig) => {
  // Use setDoc with merge: true to create document if it doesn't exist, or update if it does
  // This is especially important for partner users whose device documents may not exist yet
  return setDoc(getDeviceSettingsDocRef(deviceId), { ...deviceConfig }, { merge: true });
};

export const getDeviceSettings = (deviceId) => {
  return getDoc(getDeviceSettingsDocRef(deviceId));
};

export const getDeviceStatus = (deviceId) => {
  let docRef = doc(db, `device-status/${deviceId}`);
  return getDoc(docRef);
}

export const getDeviceSettingsGeoFences = (deviceId) => {
  return getDoc(getDeviceSettingsGeoFencesDocRef(deviceId));
};
// this function is used to set the settings payload to server, and it syncs to device from server.
// replicated this from the other repo.
export const setTasks = async (deviceId, typeOfAlert, payload) => {
  try {
    // console.log('inside setTasks:', deviceId);
    // console.log('inside setTasks:', typeOfAlert);
    // console.log('inside setTasks:', payload);
    const tasksRef = doc(db, 'tasks', deviceId);
    await setDoc(tasksRef, {
      deviceId,
      type: typeOfAlert,
      payload
    });
  } catch (error) {
    console.log('Error found while setting tasks!', error);
  }
};
